
// ─── Leasing Preisberechnung ──────────────────────────────────────────────────

window.LeasingPrice = window.LeasingPrice || (function () {

    const CONFIG = {
        MARKUP:   1.10, 
        DISCOUNT: 0.60, 
        MONTHS:   36,   
    };

  // ─── Formatierung ──────────────────────────────────────────────────

    function formatMoney(cents) {
        return new Intl.NumberFormat('de-DE', {
            style:    'currency',
            currency: 'EUR',
        }).format(cents / 100);
    }

    const priceFormatter = new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    function formatMoneyRaw(cents) {
        return priceFormatter.format(cents / 100); 
    }

  // ─── Kernberechnung (immer in Cent) ────────────────────────────────

  function calcLeasingBase(priceCents, compareAtPriceCents) {

    if (!compareAtPriceCents || compareAtPriceCents <= 0) {
      return priceCents;
    }

    const base = priceCents * 1.10;
    return base > compareAtPriceCents
      ? compareAtPriceCents
      : base;
  }

  function calcMonthlyLeasing(priceCents, compareAtPriceCents) {
    const base = calcLeasingBase(priceCents, compareAtPriceCents);
    return Math.round((base * CONFIG.DISCOUNT) / CONFIG.MONTHS);
  }

  // ─── DOM Updates ───────────────────────────────────────────────────

  function updatePDP(monthlyCents) {
    const el = document.querySelector('[data-leasing-monthly]');
    if (el) el.textContent = formatMoney(monthlyCents);
  }

  function updateOverlayInfo(variant) {
    if (!variant) return;

    const priceCents     = variant.price;
    const compareAtCents = variant.compare_at_price || 0;
    const leasingBase    = calcLeasingBase(priceCents, compareAtCents);
    const monthly        = calcMonthlyLeasing(priceCents, compareAtCents);

    // ── Bild ────────────────────────────────────────────────────────
    const overlayImage = document.querySelector('[data-product-featured-image]');
    const imageUrl =
      variant.featured_image?.src ??
      variant.featured_image?.url ??
      (typeof variant.featured_image === 'string' ? variant.featured_image : null) ??
      overlayImage?.src ??
      null;
    const imageAlt = variant.featured_image?.alt || variant.title || '';

    if (imageUrl && overlayImage) {
      overlayImage.src = imageUrl;
      overlayImage.alt = imageAlt;
      overlayImage.setAttribute('data-variant-id', variant.id);
    }

    // ── Titel & SKU ─────────────────────────────────────────────────
    const titleContent = variant.name || variant.title || '';
    const skuContent   = variant.sku  || '';

    const overlayTitle = document.getElementById('product-info__title');
    const overlaySKU   = document.getElementById('product-info__sku');
    if (overlayTitle) overlayTitle.innerHTML = titleContent;
    if (overlaySKU)   overlaySKU.textContent = skuContent;

    // ── Preisanzeige im Formular-Header ─────────────────────────────
    const overlayPrice = document.querySelector('.leasing-price');
    if (overlayPrice) overlayPrice.textContent = formatMoney(leasingBase);

    // ── PDP monatliche Rate ─────────────────────────────────────────
    updatePDP(monthly);

    // ── Hidden inputs ───────────────────────────────────────────────
    const hiddenFields = {
      '#leasing_form_price':         formatMoneyRaw(leasingBase),
      '#leasing_form_variant_title': variant.title || '',
      '#leasing_form_sku':           skuContent,
    };
    Object.entries(hiddenFields).forEach(([sel, val]) => {
      const el = document.querySelector(sel);
      if (el) el.value = val;
    });

    // ── Summary ─────────────────────────────────────────────────────
    const summaryBikeTitle = document.getElementById('summary-bike-title');
    const summaryBikeSku   = document.getElementById('summary-bike-sku');
    const summaryBikePrice = document.getElementById('summary-bike-price');
    if (summaryBikeTitle) summaryBikeTitle.textContent = titleContent;
    if (summaryBikeSku)   summaryBikeSku.textContent   = `SKU: ${skuContent}`;
    if (summaryBikePrice) summaryBikePrice.textContent = formatMoney(leasingBase);

    // ── Custom Event für externe Listener ───────────────────────────
    document.dispatchEvent(new CustomEvent('leasing:updated', {
      detail: { variantId: variant.id, priceCents, compareAtCents, leasingBase, monthly }
    }));
  }

  // ─── Init ──────────────────────────────────────────────────────────
  function initPDP() {
    const variantsEl = document.getElementById('product-variants-json');
    if (!variantsEl) return;

    let variants;
    try {
      variants = JSON.parse(variantsEl.textContent);
    } catch (e) {
      console.error('[Leasing] Parse-Fehler:', e);
      return;
    }

    const variantMap = new Map(variants.map((v) => [v.id, v]));

    function handleVariantChange(variantId) {
      const variant = variantMap.get(Number(variantId));
      if (variant) updateOverlayInfo(variant);
    }

    // Initialer Render
    const urlVariantId = new URLSearchParams(window.location.search).get('variant');
    const initialId    = urlVariantId || (variants[0] && String(variants[0].id));
    if (initialId) handleVariantChange(initialId);

    // ── Event Listener ──────────────────────────────────────────────
    ['variant:changed', 'variant:change'].forEach((eventName) => {
      document.addEventListener(eventName, (e) => {
        const id = e?.detail?.variant?.id;
        if (id) handleVariantChange(String(id));
      });
    });

    // Fallback: hidden input / select
    const variantInput =
      document.querySelector('input[name="id"]') ||
      document.querySelector('select[name="id"]');
    if (variantInput) {
      variantInput.addEventListener('change', (e) => handleVariantChange(e.target.value));
    }
  }

  // ─── Public API ────────────────────────────────────────────────────

  return { calcLeasingBase, calcMonthlyLeasing, formatMoney, initPDP, CONFIG };

})();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => LeasingPrice.initPDP());
} else {
  LeasingPrice.initPDP();
}
